<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-5"><a href="#/Leave_Tomorrow_Behind2#Contents-A">Acknowledgments</a></p>
<p class="fp">Much thanks goes to:</p>
<p class="body">Lydia and Sharon Hartzler for sharing their knowledge about cows and 4-H, answering my questions practically before I asked them, and giving me great ideas. I’m glad my questions about manure could offer family suppertime conversation.</p>
<p class="body">KB Inglee and Elizabeth “Bodge” Inglee-Richards, and Ron Baldridge, DVM, for their veterinary expertise and willingness to answer strange questions about medicines and animal health.</p>
<p class="body">Cindy Luginbill, for answering questions about salons and day spas.</p>
<p class="body">Lee Diller, for being a great boss at my “other” job.</p>
<p class="body">Nancy Clemens for being an awesome and speedy first reader, and always encouraging my dream.</p>
<p class="body">Steve, Tristan, and Sophia Smucker for being wholly supportive and enthusiastic about my writing life, and for being the best family I could ask for.</p>
<p class="body">My wonderful, wonderful readers, who asked many times when Stella would be coming back to visit. I’m so glad you insisted.</p>
<p class="body">The team at Poisoned Pen Press for their camaraderie, flexibility, and way of making this job so fun.</p>
<p class="body">If I changed information about 4-H, or veterinary meds, or beauty salons, or the recording industry, it was purely because of literary license. The people I named all know their stuff.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Leave_Tomorrow_Behind-4.vue?7ec20634